export const account = {
  manage: 'Manage my account',
  logout: 'Log out',
  update: 'Update',
  name: 'Name',
  lastName: 'Last name',
  firstName: 'First name',
  dob: 'Date of birth',
  address: 'Address',
  gender: 'Assigned sex at birth',
  yourGender: 'Assigned sex at birth',
  preferredLanguage: 'Preferred language',
  yourPreferredLanguage: 'Your preferred language',
  male: 'Male',
  female: 'Female',
  preferNotToAnswer: 'I prefer not to answer',
  addNew: 'Add a new person',
  inviteNewPerson: 'Invite a new person',
  confirm: 'Confirm',
  edit: 'Edit',
  review: 'Review',
  patientProfile: 'Profile',
  personalInformation: 'Personal information',
  contactInfo: 'Contact information',
  reviewPersonalInfo: 'Could you please review and confirm your information?',
  setPreferredLanguage: 'Set your preferred language',
  currentlyUsing: 'We are currently using the following phone number and email to log into your account.',
  updatePhone: 'Update your phone number.',
  updateEmail: 'Update your email.',
  phoneUpdated: 'Your phone number has been successfully updated!',
  emailUpdated: 'Your email has been successfully updated!',
  emailCredential: 'We will be using the following email as your login credential.',
  phoneCredential: 'We will be using the following phone number as your login credential.',
  reviewEmail: 'Could you please review and confirm your email?',
  reviewPhone: 'Could you please review and confirm your phone number?',
  reviewAddress: 'Could you please review and confirm your address?',
  digitCode: 'Please enter the 6-digit code.',
  emailConfirmation: 'We’ve sent you an email to verify.',
  phoneConfirmation: 'We’ve sent you an sms to verify.',
  addPhoto: 'Add profile photo',
  updateIssue: 'We’re having an issue updating your account.',
  getInTouch:
    'Our team is here to support you. Don’t hesitate to get in touch with us to request this update to your patient information.',
  startChat: 'Start chat',
  userDisconnected: '{{ name }} has been disconnected from your account.',
  healthInsurance: 'Your health insurance',
  makeUpdateInsurance: 'Please feel free to make any updates to your current insurance or add other coverage.',
  addOtherInsurance: 'Add Other Insurance',
  insuranceCarrier: 'Insurance carrier',
  planNumber: 'Plan number',
  couldYouReviewInsurance: 'Could you please review and confirm your insurance information?',
  setInsuranceCarrier: 'Search for insurance carrier',
  nicePhoto: 'Nice photo!',
  perfectLetsFinish: 'Perfect! Let’s finish up.',
  couldYouPleaseConfirm: 'Could you please confirm the following information?',
  couldYouPleaseEnter: 'Could you please enter the following information?',
  insuranceCard: '{{ side }} of your card',
  addInsurane: 'Let’s add your insurance information.',
  positionCard: 'Position your insurance card inside this frame.',
  groupName: 'Group Name',
  groupNumber: 'Group Number',
  relationship: 'Relationship',
  effectiveDate: 'Effective Date',
  EffectiveDate: 'Effective Date',

  personalDetails: 'Personal details',
  insurance: 'Insurance information',
  primaryProvider: 'Primary care provider',
  preferredPharmacy: 'Preferred pharmacy',
  noPharmacy: 'We currently don’t have your preferred pharmacy on file.',
  updatePreferredPharmacy: 'Please feel free to update your current preferred pharmacy.',
  preferredPharmacyLabel: 'Preferred pharmacy',
  reviewPreferredPharmacy: 'Please review and confirm your preferred pharmacy.',
  changeImg: 'Change profile photo',
  phoneNum: 'phone number',
  email: 'email',
  searchPharmacy: 'Search for a pharmacy.',
  usingLocation: 'Using your location',
  bestCare: 'Let`s figure out the best level of care for {{ name }}, together.',
  noSearchResults: 'No results.',

  connectedAccounts: 'Connected profiles',
  accounts: 'Accounts',
  manageAccounts: 'Manage connected accounts',

  healthSummary: 'Health summary',
  medications: 'Medications',
  medicalHistory: 'Medical history',
  labResults: 'Lab results',
  logOut: 'Log Out',
  changePrimaryAccoun: 'Change Primary Account',
  backToAccounts: 'Back to Account',
  backToConnectedAccounts: 'Back to Connected Accounts',
  chnagedAccount: 'We’re all set! {{ name }} is now the primary account.',
  cancel: 'Cancel',
  transferOver: 'All the current accounts associated with you will transfer over to {{ name }}.',
  changeAccount: 'Change the primary account to {{ name }}?',
  addInsurance: 'Add Insurance',
  noInsurance: 'We currently don’t have any insurance on file.',
  updateInsurance: 'Please update your insurance information.',
  connectedSet: 'We’re all set! You’re connected to {{ name }}’s patient account.',
  noConnected: 'Currently, there are no accounts with access to {{ name }}.',
  subscriptions: 'Subscriptions',
  primeProgram: 'Your {{program}} Program',
  yourSub: 'Your subscriptions',
  renews: 'Renews {{ date }}',
  haveQuestion: 'Have questions?',
  paymentMethod: 'Payment method',
  deliveryMethod: 'Delivery method',
  monthluSubscription: 'Monthly subscription',
  primeProgramIncludes: 'Your {{program}} Program includes:',
  primeSubscription: '{{program}} Subscription',
  homeDelivery: 'Home delivery',
  freeConsultation: 'Get a free consultation with our medical team now!',
  scheduledPaymentDate: 'Scheduled for payment on {{ date }}.',
  confirmAddress: 'Please review and confirm your address',
  addAddress: 'Add Address',
  removeAddress: 'Are you sure you want to delete this address?',
  updateAddress: 'Update address',
  defaultAddress: 'This is your default address.',
  yourShippingAddress: 'Your delivery address',
  default: 'Default',
  addAnAddress: 'Add an address',
  perMonth: 'Per month',
  paymentConfirmation: 'We’ve successfully received your payment!',
  sendYouOrderReceipt: 'We will send you your order receipt to your phone number and email.',
  failedPayment: 'It looks like your payment didn’t go through.',
  updatePaymentProgram: 'Let’s update your payment details to continue your program.',
  wecouldnt: 'We couldn’t process your',
  payment: 'payment on {{ date }}',
  cardEnding: ' (card ending in {{ card }}).',
  setDefaultAddress: 'Set as your default address.',
  subscriptionOption: 'Please select one of the options below.',
  pauseSubscription: 'Pause subscription',
  temporarilyPause: 'Temporarily pause your subscription while keeping your benefits on hold.',
  cancelSub: 'Cancel subscription',
  endSub: 'End your subscription permanently and lose access to program features.',
  manageSub: 'Manage Your Subscription',
  reason: 'Reason',
  shareYourFeedback: 'Share your feedback',
  whyPause: 'Please let us know why you’re pausing—your feedback helps us improve!',
  whyCancel: 'Please let us know why you’re cancelling—your feedback helps us improve!',
  subscriptionPaused: 'Your {{program}} Program subscription is paused.',
  subscriptionCanceled: 'Your {{program}} Program subscription is cancelled.',
  stayInTouch: 'We’ll stay in touch with helpful tips and updates while your subscription is on hold.',
  stayInTouchTips: 'We’ll stay in touch with helpful tips and updates.',
  noActiveSub: 'We currently don’t have any active subscriptions on file.',
  selectProfile: 'Select a profile',
  currentProfile: 'Your current profile',
  switchBetweenProfiles: 'Switch between profiles with one log-in.',
  actions: {
    edit: 'Edit',
    confirm: 'Confirm',
    verify: 'Verify',
    cancel: 'Cancel',
    updateEmail: 'Update email',
    updatePhone: 'Update phone number',
    backToContact: 'Back to Contact Information',
    findPrescriptions: 'Find Your Prescriptions',
    requestRefill: 'Request Refill',
    sentRefillRequest: 'Sent Refill Request',
    callMedicalOffice: 'Call Medical Records Office',
    downloadForm: 'Download Request Form',
    downloadResults: 'Download Results',
    download: 'Download',
    downloading: 'Downloading...',
    change: 'Change',
    goBack: 'Go Back',
    addPharmacy: 'Add Pharmacy',
    review: 'Review',
    update: 'Update',
    continue: 'Continue',
    disconnect: 'Disconnect',
    cancelRequest: 'Cancel Request',
    yesSendRequest: 'Yes, send request to access.',
    noDoNotRequest: 'No, do not request to access.',
    acceptRequest: 'Accept Request',
    denyRequest: 'Deny Request',
    upload: 'Upload',
    disconnectAccess: 'Disconnect Access',
    takePhoto: 'Take a photo of my insurance card.',
    manuallyAdd: 'Manually enter my insurance information.',
    addNewPerson: 'Add new person',
    manageSub: 'Manage Subscription',
    meetWithUs: 'Meet with Us',
    delete: 'Delete',
    save: 'Save',
    deleteAddress: 'Delete Address',
    updatePayment: 'Update payment method',
    cancelSubscription: 'Cancel Subscription',
    returnHome: 'Return Home',
    submit: 'Submit',
    learnMore: 'Learn More',
    updatePaymentMethod: 'Update Payment Method',
    addAnotherProfile: 'Add Another Profile',
    close: 'Close',
    done: 'Done',
    uploadProfilePhoto: 'Upload A Profile Photo',
  },
  preferredInusrance: 'Preferred insurance',
  chooseInsurance: 'Look up your insurance.',
  reviewInsurance: 'Please review and confirm your Insurance.',
  prescriptionSavings: 'Prescription savings',
  saveUp: 'Save up to 80% on your prescriptions',
  currentMedications: 'Current medications',
  reportedIssue: 'Reported issues',
  noCurrentMedications: 'We don’t have any current medications on file.',
  reportedMonth: 'Last 6 months',
  noReportedIssue: 'We currently do not have any recently reported issues.',
  allergies: 'Allergies',
  noAllergies: 'We currently do not have any records of allergies on file.',
  immunizations: 'Immunizations',
  noImmunizations: 'We currently do not have any immunization records on file.',
  medicalRecords: 'Medical records',
  contactMedicalOffice: 'Please contact our medical records office for further information.',
  results: 'Results',
  noResults: 'We do not have any lab results on file at the moment.',
  documents: 'Documents',
  noDocuments: 'We currently do not have any documents on file at the moment.',
  haveOtherCoverage: 'Yes, I have other coverage.',
  dontHaveOtherCoverage: 'No, I don’t have other coverage.',
  selectRelationship: 'Select relationship',

  peopleWithAccess: 'People with access to {{ name }}’s account.',
  youCanManageAccess: 'You can manage who has access to your account and control what information they can see.',
  sharePersonDetails: 'Please share with us the details of the person you wish to add.',
  relationshipTo: 'Relationship to you:',
  relationshipToPatient: 'Relationship to the patient:',
  pleasereviewAndConfirmToSend: 'Could you please review and confirm  {{ name }}’s information?',
  invitationSent: 'Your request to connect and access {{ name }}’s account has been sent!',
  weWillNotifyYou: 'We will notify you once it has been accepted.',
  permissions: 'Permissions',
  transferAccess: 'Transfer Access',
  toGrantPrimaryAccess:
    'To grant primary access to {{ name }}’s patient account, please provide a phone number or email address that {{ name }} has secure and private access to.',
  enterNewEmailPhone: 'Enter new phone number or email',
  transferRequestSent: 'Your transfer request has been sent to {{ contact }}.',
  feelFreeToCancelrequest: 'Feel free to cancel this request until the transfer has been confirmed.',
  confirmAuthority: 'I am authorized to seek medical care for this patient.',
  weNoticedThatPatient: 'We noticed that {{ name }} already has a patient account with us.',
  wouldYouLikeRequestAccess: 'Would you like to request authorized access to their patient account?',
  requestingAccessTo: '{{ name }} is requesting authorized access to {{ patientName }}’s patient account.',
  reviewRequesterDetails: 'Please review the requester’s details and decide whether to accept or deny the request.',
  requester: 'Requester',
  uploadYourPhoto: 'Would you like to upload a profile photo?',
  permissionsCard:
    '{{ name }}’s account is configured to use the same phone number as {{ connectedName }} at {{ number }}, providing full access.',
  weAreAllSet: 'We’re all set! {{ name }} is now connected to your account.',
  successfullyDenied:
    'We have successfully denied {{ requesterName }}’s request to access {{ approverName }}’s patient profile.',
  pleaseFeelFreeToClose: 'Please feel free to close this browser to exit.',
  confirmDisconnect: 'Please confirm that you want to disconnect {{ name }} from your account.',
  newAccessToAccount: 'Hi {{ approver }}, the following {{ contactType }} has been added to your account: {{contact }}',
  verifyDob: 'To help keep your information secure, could you please verify your date of birth.',
  viewMedicalRecords: 'View medical records',
  viewAppointmentHistory: 'View appointment history',
  scheduleCare: 'Schedule care',
  viewAppointmentSchedule: 'View appointment schedule',
  dobCantVerify: 'The date of birth you entered cannot be verified.',
  dobCantVerifySubtitle:
    'Our team at Next Level is here to support you. If you believe this is a mistake, we’ll be happy to help you get access to the Next Level app.',
  relations: {
    grandparent: 'Grandparent',
    childDependent: 'Child/dependent',
    spouse: 'Spouse',
    friend: 'Friend',
    primaryAccount: 'Primary account',
    parent: 'Parent/guardian',
    other: 'Other',
    child: 'Child',
    self: 'Self',
    dependent: 'Dependent',
  },
  aria: {
    takePhoto: 'Take photo',
  },
  transferCanceled: 'The transfer of primary account access from {{ requester }} to {{ approver }} has been canceled.',
  transferAccepted: '{{ approver }}’s account access has been successfully transferred to {{ contact }}.',
  accessRemoved: '{{ requester }}’s access has been removed.',
  PolicyholderLastName: 'Policy holder last name',
  PolicyholderFirstName: 'Policy holder first name',
  MemberId: 'Member id',
  CarrierName: 'Carrier name',
  PlanNumber: 'Plan number',
  GroupNumber: 'Group number',
  GroupName: 'Group name',
  pending: 'Pending',
  couldntProcessPayment: 'We couldn’t process your payment.',
  pleaseUpdatePaymentmethod: 'Please update your payment method to continue your program.',
  haveQuestions: 'Have questions? We can help you guide through your options.',
  updatePaymentMethodToContinue: 'Update payment method to continue the program.',
  errors: {
    failedToGetConnected: 'Failed to get connected accounts',
    failedToSwitch: 'Failed to switch to selected account',
    failedToUpdateAddress: 'Failed to update address information',
    failedToUpdateContact: 'Failed to update contact information',
    failedToValidate: 'Failed to validate contact information',
    failedToVerify: 'Failed to verify code',
    failedToGetInsurance: 'Failed to load insurance information',
    failedToUpdateInsurance: 'Failed to update insurance information',
    failedToAddInsurance: 'Failed to add insurance',
    failedToGetLanguages: 'Failed to get available languages',
    failedToUploadPhoto: 'Failed to upload profile photo',
    failedToRefreshProfile: 'Failed to refresh profile information',
    failedToGetPharmacy: 'Failed to get patient’s pharmacy',
    failedToSearchPharmacies: 'Failed to search pharmacies',
    failedToSavePharmacy: 'Failed to save pharmacy',
    failedToGetMedications: 'Failed to get medications',
    failedToRequestMedRefill: 'Failed to send refill request',
    failedToGetMedHistory: 'Failed to get medication history',
    failedToGetLabResults: 'Failed to get lab results',
    failedToDownloadResults: 'Failed to download lab results',
    failedToGetDocuments: 'Failed to get documents',
    failedToDownloadDocument: 'Failed to download document',
    failedToCaptureInsurance: 'Failed to capture insurance information',
    failedToSwitchToPrimary: 'Failed to switch to primary account',
    failedToSwitchToConnected: 'Failed to switch to connected account',
    failedToRefresh: 'Failed to refresh patient details',
  },
};
